<div class="col-xs-12 col-sm-6 col-md-4 m-b-20">
  <div class="group" [formGroup]="group">
    <label class="placeholder_white custom_label" [for]="wid" [class.labelEllipsis]="config.label && config.label.length > 30">
      {{config.label|translate}}
    </label>
    <a data-toggle="popover" data-placement="bottom" title="{{config.label|translate}}"
      *ngIf="config.label && config.label.length > 30">
      <i class="icon-info labelHelpIcon"></i>
    </a>
    <input class="form-control" type="hidden" [formControlName]="config.name" />
    <input type="text" [id]="wid" class="form-control" [value]="formattedDateTime" readonly />
  </div>
</div>
